import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthHandlerComponent } from './auth-handler/auth-handler.component';

const routes: Routes = [
    {
        path: 'public/completed-window/:social_media',
        component: AuthHandlerComponent,
    },

    {
        path: 'tg-landing',
        loadComponent: () => import('./tg-landing/tg-landing.component').then(m => m.TgLandingComponent),
    },
    {
        path: 'tglogin',
        loadComponent: () => import('./tg-login/tg-login.component').then(m => m.TgLoginComponent),
    },
    {
        path: '**',
        redirectTo: '/',
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PublicRoutingModule {}
